import React, { useState } from 'react'

import { useIntl } from 'react-intl'
import {
  Button,
  MessageBox,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  SpacingVertical,
  SPACING_32
} from 'mailup-web-components'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'
import { modalSave } from 'Pages/MessageEdit/recoil/state/modals'

import InputTitle from 'Pages/MessageEdit/ModalSave/InputTitle'
import {
  editorState,
  beePluginState
} from 'Pages/MessageEdit/recoil/state/editor'

export const ModalSave = () => {
  const intl = useIntl()

  const { show, variant } = useRecoilValue(modalSave)
  const closeModal = useResetRecoilState(modalSave)
  const setEditor = useSetRecoilState(editorState)
  const [valid, setValid] = useState(false)

  const { instance: beePluginInstance } = useRecoilValue(beePluginState)

  const handleChange = value => {
    setEditor(prev => ({
      ...prev,

      subject: value
    }))
    setValid(value.length > 0)
  }
  const handleSave = () => {
    beePluginInstance.save()
    closeModal()
  }

  return (
    <Modal
      show={show}
      showClose
      onClose={closeModal}
      closeOnOverlayClick={false}
      data-mu-test='modal-message-save'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.Bee.ModalTitleForMessage'
        })}
      />
      <ModalBody>
        {variant === 'quickSend' && (
          <>
            <MessageBox
              title={intl.formatMessage({
                id: 'Load.Bee.ModalLabelForMessageQuickSend'
              })}
              variant='info'
            />
            <SpacingVertical variant={SPACING_32} />
          </>
        )}

        {variant === 'preview' && (
          <>
            <MessageBox
              title={intl.formatMessage({
                id: 'Load.Bee.ModalLabelForMessagePreview'
              })}
              variant='info'
            />
            <SpacingVertical variant={SPACING_32} />
          </>
        )}

        <InputTitle onChange={handleChange} />
      </ModalBody>
      <ModalFoot>
        <Button
          data-mu-test='button-message-save-confirm'
          onClick={handleSave}
          kind='primary'
          disabled={!valid}
        >
          {intl.formatMessage({
            id: 'Load.Common.Save'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}
